import { COUNTRIES, DEFAULT_COUNTRY } from '@onefootprint/core';
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';

const getInitialCountry = (initialCountryCode?: Iso3166TwoDigitCountryCode) => {
  if (initialCountryCode) {
    const possibleCountry = COUNTRIES.find(country => country.value === initialCountryCode);
    return possibleCountry || DEFAULT_COUNTRY;
  }
  return DEFAULT_COUNTRY;
};

export default getInitialCountry;
